import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppSettings} from '../../proyect.conf';
import {map} from 'rxjs/operators';
import {ProductoGarantiaIdonea} from '../_models/producto-garantia-idonea';

@Injectable({
  providedIn: 'root'
})
export class ProductoGarantiaIdoneaService {
  private rutService = AppSettings.rutServiciosAPL + '/api/productosGarantiasIdoneasModalidades' ;
  constructor(
    private http: HttpClient,
  ) { }

  obtenerProductoGarantiaIdoneasModalidades(idProducto: string) {
    return this.http.get(`${this.rutService}/producto/${idProducto}`)
      .pipe( map( res => res as ProductoGarantiaIdonea[] ) );
  }

  crear(obj) {
    return this.http.post(`${this.rutService}`,obj)
      .pipe( map( res => res as ProductoGarantiaIdonea[] ) );
  }

  actualizar(obj) {
    return this.http.put(`${this.rutService}`,obj)
      .pipe( map( res => res as ProductoGarantiaIdonea[] ) );
  }

}
